import Caret from '@clearkit/icons/glyphs/Caret';
import GoExternal from '@clearkit/icons/glyphs/GoExternal';
import Salesforce from '@clearkit/icons/glyphs/Salesforce';
import {
  CKActionMenu,
  CKButton,
  CKCompanyLogo,
  CKPopover,
} from '@clearkit/react';
import compact from 'lodash/compact';

import { dollars } from '~/lib/formatters';

import styles from './styles';
import TwoLineMenuItem from './TwoLineMenuItem';

const Actions = ({
  classes = {},
  salesforceContacts,
  salesforceAccountConnector,
  salesforceLeads,
}) => {
  const numberOfLeads = salesforceLeads.length;
  const numberOfContacts = salesforceContacts.length;

  if (numberOfContacts === 0 && numberOfLeads === 0) return null;

  const names = compact([
    numberOfLeads && (numberOfLeads === 1 ? 'lead' : 'leads'),
    numberOfContacts && (numberOfContacts === 1 ? 'contact' : 'contacts'),
  ]).join(' & ');

  const buttonLabel = `${numberOfLeads + numberOfContacts} ${names}`;

  return (
    <div className="flex flex-row">
      {(salesforceContacts?.length > 0 || salesforceLeads?.length > 0) && (
        <CKPopover
          className="z-20 overflow-y-auto popover-max-height"
          aria-label="Popover"
          options={{ placement: 'bottom-end', gutter: 4 }}
          popover={
            <CKActionMenu
              aria-label="Default Menu"
              hideOnClickOutside={false}
              visible>
              {salesforceContacts?.map((salesforceContact) => {
                return (
                  <div key={salesforceContact.externalId}>
                    <span className="px-3 pt-1 pt-2 text-sm font-medium text-gray">
                      {salesforceContact.opportunities?.length}{' '}
                      {salesforceContact.opportunities?.length == 1
                        ? 'opportunity'
                        : 'opportunities'}
                    </span>
                    <CKActionMenu.Item
                      as="a"
                      href={`${salesforceAccountConnector.externalInstanceUrl}/${salesforceContact.externalId}`}
                      target="blank"
                      rel="noopener noreferrer"
                      icon={
                        <CKCompanyLogo
                          domain={salesforceContact.websiteDomain}
                          size={32}
                        />
                      }>
                      <span className="flex flex-row items-center flex-grow">
                        <TwoLineMenuItem
                          title={salesforceContact.name}
                          subtitle={
                            <>
                              Owner &mdash;{' '}
                              {salesforceContact?.owner?.name || 'Unknown User'}
                            </>
                          }
                        />
                        <GoExternal className="ml-auto text-blue-500" />
                      </span>
                    </CKActionMenu.Item>
                    {salesforceContact?.opportunities?.length > 0 && (
                      <span className="px-3 pt-1 pt-2 text-sm font-medium text-gray">
                        {salesforceContact.opportunities?.length}{' '}
                        {salesforceContact.opportunities?.length == 1
                          ? 'opportunity'
                          : 'opportunities'}
                      </span>
                    )}
                    {salesforceContact?.opportunities?.map((opportunity) => {
                      return (
                        <CKActionMenu.Item
                          key={opportunity.externalId}
                          as="a"
                          href={`${opportunity.accountConnector.externalInstanceUrl}/${opportunity.externalId}`}
                          target="blank"
                          rel="noopener noreferrer">
                          <span className="flex flex-row items-center flex-grow">
                            <TwoLineMenuItem
                              title={opportunity.name}
                              subtitle={
                                <>
                                  Owner &mdash;{' '}
                                  {opportunity.owner?.name || 'Unknown User'} -{' '}
                                  {dollars(opportunity.amount)}
                                </>
                              }
                            />
                          </span>
                        </CKActionMenu.Item>
                      );
                    })}
                    {salesforceContact !==
                      salesforceContacts[salesforceContacts?.length - 1] && (
                      <CKActionMenu.Divider />
                    )}
                  </div>
                );
              })}

              {salesforceLeads?.map((salesforceLead) => {
                return (
                  <div key={salesforceLead.externalId}>
                    <span className="px-3 pt-1 pt-2 text-sm font-medium text-gray">
                      Lead &mdash; {salesforceLead.name}
                    </span>
                    <CKActionMenu.Item
                      as="a"
                      href={`${salesforceAccountConnector.externalInstanceUrl}/${salesforceLead.externalId}`}
                      target="blank"
                      rel="noopener noreferrer"
                      key={salesforceLead.externalId}
                      icon={
                        <CKCompanyLogo
                          domain={salesforceLead.websiteDomain}
                          size={32}
                        />
                      }>
                      <span className="flex flex-row items-center flex-grow">
                        <TwoLineMenuItem
                          title={salesforceLead.name}
                          subtitle={
                            <>
                              Owner &mdash;{' '}
                              {salesforceLead?.owner?.name || 'Unknown User'}
                            </>
                          }
                        />
                        <GoExternal className="ml-auto text-blue-500" />
                      </span>
                    </CKActionMenu.Item>
                    {salesforceLead?.opportunities?.length > 0 && (
                      <span className="px-3 pt-1 pt-2 text-sm font-medium text-gray">
                        {salesforceLead.opportunities?.length}{' '}
                        {salesforceLead.opportunities?.length == 1
                          ? 'opportunity'
                          : 'opportunities'}
                      </span>
                    )}
                    {salesforceLead?.opportunities?.map((opportunity) => {
                      return (
                        <CKActionMenu.Item
                          key={opportunity.externalId}
                          as="a"
                          href={`${opportunity.accountConnector.externalInstanceUrl}/${opportunity.externalId}`}
                          target="blank"
                          rel="noopener noreferrer">
                          <span className="flex flex-row items-center flex-grow">
                            <TwoLineMenuItem
                              title={opportunity.name}
                              subtitle={
                                <>
                                  Owner &mdash;{' '}
                                  {opportunity.owner?.name || 'Unknown User'} -{' '}
                                  {dollars(opportunity.amount)}
                                </>
                              }
                            />
                          </span>
                        </CKActionMenu.Item>
                      );
                    })}
                    {salesforceLead !==
                      salesforceLeads[salesforceLeads?.length - 1] && (
                      <CKActionMenu.Divider />
                    )}
                  </div>
                );
              })}
            </CKActionMenu>
          }>
          <CKButton
            className={classnames(classes.salesforceButton, 'ml-4')}
            leftIcon={<Salesforce className="mr-1" />}
            rightIcon={<Caret className="-mr-1" />}>
            {buttonLabel}
          </CKButton>
        </CKPopover>
      )}
    </div>
  );
};

Actions.propTypes = {
  classes: PropTypes.object,
  hubspotCompanies: PropTypes.array,
  salesforceLeads: PropTypes.array,
  salesforceContacts: PropTypes.array,
  hubspot: PropTypes.object,
  salesforceAccountConnector: PropTypes.shape({
    externalInstanceUrl: PropTypes.string,
  }),
};

export default withStyles(styles)(Actions);
